export const COMMENTS = 'COMMENTS';
export const HIGHLIGHTS = 'HIGHLIGHTS';
export const SLIDES = 'SLIDES';
export const CHAPTERS = 'CHAPTERS';
